import React from "react";
import NumberHorizontalLayout from "../../layouts/NumberHorizontalLayout";
import classnames from "classnames";
import selectFormat from "../selectFormat";
import metricDefinitions from "../../metricDefinitions";
import { useSelector } from "react-redux";

export default function GeneralOutcomesData(props) {
  const { organization_name, permissions } = useSelector(
    (state) => state.static
  );
  const { hiddenOutcomes } = useSelector((state) => state.settings);
  let metrics = metricDefinitions(organization_name, permissions)["general"]
    .metrics;
  return (
    <div className="col-12 pb-5">
      {metrics
        .filter(
          (metric) =>
            metric.visible == true &&
            !hiddenOutcomes.includes(metric.outcome_slug)
        )
        .map((metric, index) => {
          return selectFormat(metric, index, props);
        })}
      <div className="py-3" />
    </div>
  );
}
